<div class="d-none" [id]="id">
    <ng-template #body></ng-template>
    <ng-container *ngIf="template" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="templateContext"></ng-container>
</div>